import React, { Component } from 'react'
import Sel from './Sel'
import PesquisaCustom from '../../CriarCustomForm/components/CriarCustomPesquisa'

export default class SeletorUidCustomForm extends Component {

    render() {


        const { value, onChange } = this.props
        return (
            <div>
                <Sel
                    //  label={"SeletorCustomForm"}
                    pesquisa={<PesquisaCustom />}
                    toStringItem={(t) => t}
                    itemToValue={(t) => t.uid}
                    input={{ value, onChange }}
                    meta={{}}
                ></Sel>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/editor/SeletorUidCustomForm.js